document.addEventListener("DOMContentLoaded", (event) => {
	const multiselectFields = document.querySelectorAll(".multiselect-wrapper ");
	const cat = document.getElementById("cat");
	if (multiselectFields.length) {
		// Close select if not clicked
		document.addEventListener("click", (e) => {
			if (!e.target.closest(".multiselect-wrapper")) {
				multiselectFields.forEach((field) => field.classList.remove("open"));
				return;
			}
		});

		multiselectFields.forEach((field) => {
			let selectedValues = [];
			let selectedValueTexts = [];
			const select = field.querySelector("select");
			const btn = field.querySelector("button");
			const originalBtnText = btn.innerText;
			const options = select.querySelectorAll("option");

			// Prepopulate selected options
			if (select.selectedOptions.length) {
				selectedValues = Array.from(select.selectedOptions).map((option) => option.value);
				selectedValueTexts = Array.from(select.selectedOptions).map((option) => option.label);
				btn.innerHTML = "";
				btn.innerHTML = "<span class='options'></span>";
				selectedValues.forEach((option, index) => {
					const span = document.createElement("span");
					span.className = "selected-options";
					span.textContent = selectedValueTexts[index];
					btn.querySelector(".options").append(span);
				});
				cat.value = selectedValues.join(",");
			}

			options.forEach((option) => {
				option.addEventListener(
					"mousedown",
					(e) => {
						e.preventDefault();
						option.selected = !option.selected;
						return false;
					},
					false,
				);
			});

			field.addEventListener("click", (e) => {
				// Toggle dropdown
				if (e.target === btn || e.target.closest(".select")) {
					e.preventDefault();
					field.classList.toggle("open");
					if (field.classList.contains("open")) {
						btn.setAttribute("aria-expanded", true);
					} else {
						btn.setAttribute("aria-expanded", false);
					}
				}
			});

			field.addEventListener("click", (e) => {
				// Add selected items to button text
				if (e.target === select || e.target.closest(".tesl-post-categories")) {
					const selected = select.selectedOptions;
					selectedValues = Array.from(selected).map((option) => option.value);
					selectedValueTexts = Array.from(selected).map((option) => option.label);
					btn.innerHTML = "";
					btn.innerHTML = "<span class='options'></span>";
					if (selectedValues.length >= 1) {
						selectedValues.forEach((option, index) => {
							const span = document.createElement("span");
							span.className = "selected-options";
							span.textContent = selectedValueTexts[index];
							btn.querySelector(".options").append(span);
						});
					} else {
						btn.innerHTML = originalBtnText;
					}
					cat.value = selectedValues.join(",");
				}
			});
		});
	}
});
